import { Route, Routes } from 'react-router-dom'
import { TableAuthorizationPayments } from './AuthorizationPayments'


export const BrowserAuthorizationPayments = () => {
  return (
    <Routes>
      <Route path={"/"} element={<TableAuthorizationPayments />} />
    </Routes>
  )
}
